var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.useCustom)?_vm._t("custom"):(_vm.isReadOnly)?_vm._t("readonly"):(_vm.isOffline)?_vm._t("offline"):(_vm.isForbidden)?_vm._t("forbidden"):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }